// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Forgot Password — style proche Login */

.forgot_header{
  margin-top: 28px;
  margin-bottom: 18px;
}

.forgot_header h1{
  font-size: 34px;
  font-weight: 800;
  margin: 0;
}

.forgot_header p{
  margin: 10px 0 0;
  color: rgba(15, 23, 42, 0.65);
  font-size: 14px;
  line-height: 1.5;
}

.forgot_form{
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.forgot_footer{
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.forgot_back{
  font-size: 14px;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s ease, transform .15s ease;
}

.forgot_back:hover{
  opacity: .85;
  transform: translateY(-1px);
  text-decoration: underline;
}

/* Centre global */
.forgot_page{
  position: relative;
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Bloc central (comme une mini-card) */
.forgot_card{
  width: 100%;
  max-width: 520px;
  padding: 22px 18px;
}

/* Titre + texte centrés */
.forgot_header{
  text-align: center;
  margin-bottom: 18px;
}

.forgot_header h1{
  font-size: 34px;
  font-weight: 800;
  margin: 0;
}

.forgot_header p{
  margin: 10px auto 0;
  max-width: 420px;
  color: rgba(15, 23, 42, 0.65);
  font-size: 14px;
  line-height: 1.5;
}

/* Form centré */
.forgot_form{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Footer centré */
.forgot_footer{
  display: flex;
  justify-content: center;
  margin-top: 6px;
}

.forgot_back{
  font-size: 14px;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s ease, transform .15s ease;
}

.forgot_back:hover{
  opacity: .85;
  transform: translateY(-1px);
  text-decoration: underline;
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/authentification/forgot-password.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B","sourcesContent":["/* Page Forgot Password — style proche Login */\n\n.forgot_header{\n  margin-top: 28px;\n  margin-bottom: 18px;\n}\n\n.forgot_header h1{\n  font-size: 34px;\n  font-weight: 800;\n  margin: 0;\n}\n\n.forgot_header p{\n  margin: 10px 0 0;\n  color: rgba(15, 23, 42, 0.65);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.forgot_form{\n  margin-top: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.forgot_footer{\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.forgot_back{\n  font-size: 14px;\n  color: #2563eb;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity .15s ease, transform .15s ease;\n}\n\n.forgot_back:hover{\n  opacity: .85;\n  transform: translateY(-1px);\n  text-decoration: underline;\n}\n\n/* Centre global */\n.forgot_page{\n  position: relative;\n  min-height: calc(100vh - 120px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Bloc central (comme une mini-card) */\n.forgot_card{\n  width: 100%;\n  max-width: 520px;\n  padding: 22px 18px;\n}\n\n/* Titre + texte centrés */\n.forgot_header{\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n.forgot_header h1{\n  font-size: 34px;\n  font-weight: 800;\n  margin: 0;\n}\n\n.forgot_header p{\n  margin: 10px auto 0;\n  max-width: 420px;\n  color: rgba(15, 23, 42, 0.65);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Form centré */\n.forgot_form{\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* Footer centré */\n.forgot_footer{\n  display: flex;\n  justify-content: center;\n  margin-top: 6px;\n}\n\n.forgot_back{\n  font-size: 14px;\n  color: #2563eb;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity .15s ease, transform .15s ease;\n}\n\n.forgot_back:hover{\n  opacity: .85;\n  transform: translateY(-1px);\n  text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
